import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  initialScanInputValue,
  IScanInput,
} from "../../modules/pdms/model/pdms";
let initialState: IScanInput = initialScanInputValue;
const saved = localStorage.getItem("pdms_scan_input");
if (saved) {
  initialState = { ...initialScanInputValue, ...JSON.parse(saved) };
}
const ScanInputSlice = createSlice({
  name: "scan_input",
  initialState,
  reducers: {
    updateField: <K extends keyof IScanInput>(
      state: IScanInput,
      action: PayloadAction<{ field: K; value: any }>
    ) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    setScanInput: (state, action: PayloadAction<IScanInput>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { /* setScanInput, */ updateField } = ScanInputSlice.actions;
export default ScanInputSlice.reducer;
